import { render, staticRenderFns } from "./TheRecentComments.vue?vue&type=template&id=4b266738"
import script from "./TheRecentComments.vue?vue&type=script&lang=js"
export * from "./TheRecentComments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports